import React from 'react';
import { batch, useDispatch } from 'react-redux';
import { setBootstrapConfig, setLoyaltySearchType, setShowHeader, setWebViewFeatureToggle } from 'store/slice/bootstrap';
import { convertGeoToSuggestion, setTextSearchInSearchBoxSettingsState } from 'store/slice/home';
import { LanguageNotSupportedErrorModal } from 'component/common/Header/LanguageNotSupportedErrorModal';
import { AppFeaturesToggleEnum, BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { getLoyaltySearchTypeFromLocalStorage } from 'core/utils/loyaltySearchType';
import { LoyaltySearchType } from 'core/type/LoyaltySearch.types';
import { getApp } from 'core/app/appService';

function getLoyaltySearchType(config: BootstrapConfig) {
    return getLoyaltySearchTypeFromLocalStorage() || config.behavior.common.partnerLoyaltyConfiguration?.config?.defaultLoyaltyType || LoyaltySearchType.UNKNOWN;
}

const BootstrapConfigSetter: React.FC<{ config?: BootstrapConfig }> = ({ config }) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        if (!config) return;

        batch(() => {
            dispatch(setBootstrapConfig(config));

            if (config.geo && Object.keys(config.geo).length > 0) {
                const suggestion = convertGeoToSuggestion(config.geo);
                dispatch(setTextSearchInSearchBoxSettingsState(suggestion));
            }

            dispatch(setLoyaltySearchType(getLoyaltySearchType(config)));

            const setupWebViewFeatureToggles = async () => {
                const webViewFeatureToggles = await getApp().getFeatureToggles();
                dispatch(setWebViewFeatureToggle(webViewFeatureToggles));

                if (webViewFeatureToggles.includes(AppFeaturesToggleEnum.EnableActivitiesWebViewHeader)) {
                    dispatch(setShowHeader(true));
                }
            };

            if (config.isWebView) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                setupWebViewFeatureToggles();
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <LanguageNotSupportedErrorModal />;
};
BootstrapConfigSetter.displayName = 'BootstrapConfigSetter';

export default BootstrapConfigSetter;
